// Warenkorb-Drawer: „Könnte dir auch gefallen“ (snippets/mil-warenkorb-empfehlungen.liquid).
// - „Hinzufügen“ legt die gewählte Variante per Ajax in den Warenkorb und rendert den Drawer neu (wie product-form.js).
// - Hat Liquid keinen Motiv-Partner gefunden (data-anzahl="0"), füllt dieses Skript mit Shopifys Empfehlungen auf.
(function() {
  if (window.milWarenkorbBound) return;
  window.milWarenkorbBound = true;

  var MAX = 2;
  var waehrung = new Intl.NumberFormat('de-DE', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  function meldung(box, text) {
    var m = box && box.querySelector('.mil-empfehlung__meldung');
    if (!m) return;
    m.textContent = text || '';
    m.hidden = !text;
  }

  function hinzufuegen(box, variantId, knopf) {
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var routes = window.routes || {};
    var config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: { Accept: 'application/javascript' } };
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    var daten = new FormData();
    daten.append('id', variantId);
    daten.append('quantity', 1);
    if (cart) {
      daten.append('sections', cart.getSectionsToRender().map(function(s) { return s.id; }));
      daten.append('sections_url', window.location.pathname);
    }
    config.body = daten;
    if (knopf) { knopf.disabled = true; knopf.setAttribute('aria-busy', 'true'); }
    fetch(routes.cart_add_url || '/cart/add', config)
      .then(function(r) { return r.json(); })
      .then(function(antwort) {
        if (antwort.status) { meldung(box, antwort.description || antwort.message || 'Konnte nicht hinzugefügt werden.'); return; }
        if (!cart) { window.location = routes.cart_url || '/cart'; return; }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mil-warenkorb', productVariantId: variantId, cartData: antwort });
        }
        cart.renderContents(antwort);
      })
      .catch(function() { meldung(box, 'Konnte nicht hinzugefügt werden.'); })
      .finally(function() { if (knopf) { knopf.disabled = false; knopf.removeAttribute('aria-busy'); } });
  }

  document.addEventListener('click', function(e) {
    var knopf = e.target.closest && e.target.closest('[data-mil-empfehlung-hinzu]');
    if (!knopf) return;
    e.preventDefault();
    var kachel = knopf.closest('.mil-empfehlung__kachel');
    var auswahl = kachel && kachel.querySelector('[data-mil-empfehlung-variante]');
    if (!auswahl || !auswahl.value) return;
    var opt = auswahl.options[auswahl.selectedIndex];
    if (opt && opt.disabled) { meldung(knopf.closest('[data-mil-empfehlung]'), 'Diese Größe ist nicht verfügbar.'); return; }
    hinzufuegen(knopf.closest('[data-mil-empfehlung]'), auswahl.value, knopf);
  });

  // Auffüllen mit Shopify-Empfehlungen, wenn kein Motiv-Partner gefunden wurde
  function kachelHtml(p) {
    var varianten = (p.variants || []).filter(function(v) { return v.available; });
    if (!varianten.length) return '';
    var bild = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') === -1 ? '?' : '&') + 'width=160' : '';
    var name = String(p.title).split(' | ')[0];
    var preis = (p.price_varies ? 'ab ' : '') + waehrung.format(p.price_min / 100);
    var optionen = varianten.map(function(v) { return '<option value="' + v.id + '">' + esc(v.title) + '</option>'; }).join('');
    return '<li class="mil-empfehlung__kachel">' +
      '<a href="' + esc(p.url) + '" class="mil-empfehlung__bild-link" tabindex="-1" aria-hidden="true">' +
      (bild ? '<img class="mil-empfehlung__bild" src="' + esc(bild) + '" alt="" width="64" height="64" loading="lazy">' : '') + '</a>' +
      '<div class="mil-empfehlung__info"><a href="' + esc(p.url) + '" class="mil-empfehlung__name">' + esc(name) + '</a>' +
      '<span class="mil-empfehlung__preis">' + esc(preis) + '</span>' +
      '<div class="mil-empfehlung__aktion"><label class="visually-hidden" for="MilEmpfehlung-' + p.id + '">Variante für ' + esc(p.title) + '</label>' +
      '<select id="MilEmpfehlung-' + p.id + '" class="mil-empfehlung__auswahl" data-mil-empfehlung-variante>' + optionen + '</select>' +
      '<button type="button" class="mil-empfehlung__button" data-mil-empfehlung-hinzu>Hinzufügen</button></div></div></li>';
  }

  var cache = {};
  function auffuellen() {
    // Erst laden, wenn der Drawer offen ist (kein Zusatz-Request auf jeder Seite)
    if (!document.querySelector('cart-drawer.active')) return;
    var box = document.querySelector('[data-mil-empfehlung][data-anzahl="0"]:not([data-geladen])');
    if (!box) return;
    box.setAttribute('data-geladen', '');
    var id = box.getAttribute('data-produkt');
    var ausschluss = box.getAttribute('data-ausschluss') || '';
    if (!id) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var url = root + 'recommendations/products.json?product_id=' + encodeURIComponent(id) + '&limit=6&intent=related';
    (cache[url] = cache[url] || fetch(url).then(function(r) { return r.ok ? r.json() : { products: [] }; }).catch(function() { return { products: [] }; }))
      .then(function(daten) {
        if (!document.body.contains(box)) return;
        var html = (daten.products || []).filter(function(p) {
          return p.available && ausschluss.indexOf(',' + p.id + ',') === -1;
        }).slice(0, MAX).map(kachelHtml).join('');
        if (!html) return;
        box.querySelector('.mil-empfehlung__liste').innerHTML = html;
        box.hidden = false;
      });
  }

  // Der Drawer wird bei jeder Änderung neu gerendert: neue Empfehlungsbox dann auffüllen
  // und beim Öffnen (Klasse „active“ am cart-drawer)
  new MutationObserver(function() {
    if (document.querySelector('[data-mil-empfehlung][data-anzahl="0"]:not([data-geladen])')) auffuellen();
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
})();
